function transformNumbers(n) {
  return n < 10 ? `0${n}` : n;
}

export default transformNumbers;
